import { Box, IconButton, Stack, TableCell, TableRow, Tooltip, styled } from '@mui/material';
import { DeleteIcon } from '@synergy/theme-next';
import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { PoolTextField } from '@synergy/components';
import { PoolTypography, PoolVirtualTable } from '@synergy/components-next';

import { ExternalCustomerMapping, FormValues } from './external-customer-mapping';

export interface ExternalCustomerMappingTableProps {
    isCustomer: boolean;
    externalCustomerMappings: FormValues;
    onDeleteMapping: (mapping: ExternalCustomerMapping) => void;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    background: theme.palette.common.white,
}));

export const ExternalCustomerMappingTable = (props: ExternalCustomerMappingTableProps) => {
    const { isCustomer, externalCustomerMappings, onDeleteMapping } = props;

    if (externalCustomerMappings.mappings.length < 1) {
        return null;
    }

    return (
        <PoolVirtualTable
            data={externalCustomerMappings.mappings}
            fixedHeaderContent={() => (
                <TableRow sx={{ background: theme => theme.palette.common.white, whiteSpace: 'nowrap' }}>
                    <TableCell>
                        <FormattedMessage
                            id={
                                isCustomer
                                    ? 'app.contactsAndOrganizations.detail.customerExternalCustomerMapping.account'
                                    : 'app.contactsAndOrganizations.detail.supplierExternalCustomerMapping.account'
                            }
                        />
                    </TableCell>
                    <TableCell sx={{ width: '30%' }}>
                        <FormattedMessage id="app.contactsAndOrganizations.detail.supplierExternalCustomerMapping.externalId" />
                    </TableCell>
                    <TableCell sx={{ width: '1%' }} />
                </TableRow>
            )}
            rowRenderer={(mapping, index) => (
                <>
                    <StyledTableCell>
                        <PoolTypography component="span" typography="body1">
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Box>{mapping.accountName}</Box>
                            </Stack>
                        </PoolTypography>
                        <PoolTypography color="grey.700" typography="caption" component="div">
                            <Box>{mapping.accountId}</Box>
                        </PoolTypography>
                    </StyledTableCell>
                    <StyledTableCell>
                        <Box sx={{ maxWidth: 160 }}>
                            <Field name={`mappings.[${index}].externalCustomerId`}>
                                {({ field, meta }: FieldProps<string>) => (
                                    <PoolTextField
                                        {...field}
                                        label={<FormattedMessage id="app.common.externalId" />}
                                        fullWidth={true}
                                        required={true}
                                        error={!!meta.touched && !!meta.error}
                                        helperText={
                                            meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null
                                        }
                                    />
                                )}
                            </Field>
                        </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                        <Tooltip
                            title={
                                <FormattedMessage id="app.contactsAndOrganizations.detail.supplierExternalCustomerMapping.delete" />
                            }
                            placement="top"
                        >
                            <IconButton onClick={e => onDeleteMapping(mapping)}>
                                <DeleteIcon sx={{ color: theme => theme.palette.common.black }} />
                            </IconButton>
                        </Tooltip>
                    </StyledTableCell>
                </>
            )}
        />
    );
};
